import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseQueryConfig } from "../api";
import { ICreateAdminRequest } from "../models/users.models";
import { IAdminFireBase, IAdminsWithMeta } from "../models/admin.models";
import { RootState } from "../store";

const adminConfig = {
  ...baseQueryConfig,
  baseUrl: baseQueryConfig.baseUrl + "/admin",
  prepareHeaders: async (
    headers: Headers,
    { getState }: { getState: () => any }
  ) => {
    const token = await (getState() as RootState).user.user?.getIdToken();
    token && headers.set("Authorization", `Bearer ${token}`);
    headers.set("Authorization", `Bearer ${token}`);
    return headers;
  },
};

export const adminApi = createApi({
  reducerPath: "adminApi",
  tagTypes: ["Admins"],
  baseQuery: fetchBaseQuery(adminConfig),
  endpoints: (builder) => ({
    getAdmins: builder.query<IAdminsWithMeta, { page: number; limit: number }>({
      query: ({ page, limit }) => ({
        url: "/search",
        params: { page, limit },
      }),
      providesTags: ["Admins"],
    }),
    deleteAdmin: builder.mutation<boolean, { uid: string }>({
      query: ({ uid }) => ({
        url: `/delete-admin/${uid}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Admins"],
    }),
    deleteAdminEmail: builder.mutation<boolean, { email: string }>({
      query: ({ email }) => ({
        url: `/emails`,
        method: "DELETE",
        body: { email },
      }),
      invalidatesTags: ["Admins"],
    }),
    createAdmin: builder.mutation<void, ICreateAdminRequest>({
      query: (data) => ({
        url: "/create-admin",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Admins"],
    }),
    createNewAdmin: builder.mutation<void, { email: string }>({
      query: ({ email }) => ({
        url: "/emails",
        method: "POST",
        params: { email },
      }),
      invalidatesTags: ["Admins"],
    }),
    checkIsAdmin: builder.query<{ isExist: boolean }, { email: string }>({
      query: ({ email }) => ({
        url: "/check-admin-email",
        params: { email },
      }),
      providesTags: ["Admins"],
    }),
    checkIsAdminLogin: builder.query<{ isAdmin: boolean }, { email: string }>({
      query: ({ email }) => ({
        url: "/is-admin-email",
        params: { email },
      }),
      providesTags: ["Admins"],
    }),
    getAdminByEmail: builder.query<IAdminFireBase, string>({
      query: (email: string) => ({
        url: `emails/by-email?email=${email}`,
      }),
      providesTags: ["Admins"],
    }),
    getCurrentAdmin: builder.query<IAdminFireBase, string>({
      query: (email: string) => ({
        url: `by-email?email=${email}`,
      }),
      providesTags: ["Admins"],
    }),
  }),
});

export const {
  useGetAdminsQuery,
  useDeleteAdminMutation,
  useDeleteAdminEmailMutation,
  useCreateAdminMutation,
  useCheckIsAdminQuery,
  useCheckIsAdminLoginQuery,
  useGetAdminByEmailQuery,
  useGetCurrentAdminQuery,
  useCreateNewAdminMutation,
} = adminApi;

